module.exports = __webpack_public_path__ + "static/media/pay_you_allow.c6d5e5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pay_you_allow.png
// module id = 274
// module chunks = 0 1